import { AxiosInstance } from 'axios'
import { IDistrict, IRegion } from '@/api/region'
import moment from 'moment'
import { IStatus } from '@/api/status'

export function getTasksListResponse(axios: AxiosInstance, params: Object) {
  return axios({
    url: '/v1/user-tasks/adm',
    method: 'get',
    params,
  })
}

export function getTaskResponse(axios: AxiosInstance, id: string) {
  return axios({
    url: `/v1/user-tasks/adm/${id}`,
    method: 'get',
  })
}

export function getCreateTaskResponse(axios: AxiosInstance, data: Object) {
  return axios({
    url: `/v1/user-tasks/adm`,
    method: 'post',
    data,
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export function getUpdateTaskResponse(axios: AxiosInstance, id: string, data: Object) {
  return axios({
    url: `/v1/user-tasks/adm/${id}`,
    method: 'put',
    data,
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export function getCreateTaskStepResponse(axios: AxiosInstance, taskId: string, step: Object) {
  return axios({
    url: `/v1/user-tasks/adm/${taskId}/step`,
    method: 'post',
    data: step,
  })
}

export function getUpdateTaskStepResponse(
  axios: AxiosInstance,
  taskId: string,
  step_id,
  step: Object
) {
  return axios({
    url: `/v1/user-tasks/adm/${taskId}/step/${step_id}`,
    method: 'put',
    data: step,
  })
}

export function getDeleteTaskStepResponse(axios: AxiosInstance, taskId: string, step_id) {
  return axios({
    url: `/v1/user-tasks/adm/${taskId}/step/${step_id}`,
    method: 'delete',
  })
}

export enum TaskKind {
  Agitation = 1,
  Event,
  Online,
}

export function getTaskKindString(kind: TaskKind): string {
  switch (kind) {
    case TaskKind.Agitation:
      return 'Агитация'
    case TaskKind.Online:
      return 'Online'
    case TaskKind.Event:
      return 'Мероприятие'
  }
}

export const taskKinds = [TaskKind.Agitation, TaskKind.Event, TaskKind.Online]
export const taskKindSelect = taskKinds.map((x) => {
  return { value: x, text: getTaskKindString(x) }
})

export enum TaskSubKind {
  Urgent = 1,
  Regular,
  Assigment,
}

export function getTaskSubKindString(kind: TaskSubKind): string {
  switch (kind) {
    case TaskSubKind.Urgent:
      return 'Срочное'
    case TaskSubKind.Regular:
      return 'Регулярное'
    case TaskSubKind.Assigment:
      return 'Поручение'
  }
}

export const taskSubKinds = [TaskSubKind.Urgent, TaskSubKind.Regular, TaskSubKind.Assigment]
export const taskSubKindSelect = taskSubKinds.map((x) => {
  return { value: x, text: getTaskSubKindString(x) }
})

export interface ITaskScope {
  code?: string
  region?: IRegion
  districts?: IDistrict[]
}

export interface ITaskStep {
  number?: number
  description?: string
  deadline?: string
  kind?: number
}

export interface ITask {
  name: string
  description: string
  deadline: string
  kind: TaskKind
  sun_kind: TaskSubKind
  steps: ITaskStep[]
  scope: ITaskScope
}

export const defaultTaskStep: ITaskStep = {
  number: 0,
  description: '',
  deadline: '',
  kind: 0,
}

export function deadlineToDate(deadline: string): string {
  if (!deadline) {
    return ''
  }
  const date = moment(deadline)
  return date.isValid() ? date.format('YYYY-MM-DD') : ''
}

export function dateToDeadline(deadline: string): string {
  if (!deadline) {
    return ''
  }
  const date = moment(deadline)
  return date.isValid() ? date.format('YYYY-MM-DDTHH:mm:ssZ') : ''
}

export function getTakenTasksListResponse(axios: AxiosInstance, taskId: string, filters: Object) {
  return axios({
    url: `/v1/user-tasks/insp/list/${taskId}`,
    method: 'get',
    params: filters,
  })
}

export function getTakenTasksCountsResponse(axios: AxiosInstance, taskId: string) {
  return axios({
    url: `/v1/user-tasks/insp/list/${taskId}/counts`,
    method: 'get',
  })
}

export function getTakenTaskDetailResponse(axios: AxiosInstance, takenTaskId: string) {
  return axios({
    url: `/v1/user-tasks/insp/taken/${takenTaskId}/detail`,
    method: 'get',
  })
}

export function getTakenTaskStatusesResponse(axios: AxiosInstance, takenTaskId: string) {
  return axios({
    url: `/v1/user-tasks/insp/taken/${takenTaskId}/statuses`,
    method: 'get',
  })
}

export function getCreateTakenTaskStatusResponse(
  axios: AxiosInstance,
  takenTaskId: string,
  status: IStatus
) {
  return axios({
    url: `/v1/user-tasks/insp/taken/${takenTaskId}/status`,
    method: 'post',
    data: status,
  })
}

export enum TakenTaskStatus {
  Created = 1,
  InProgress = 2,
  Completed = 3,
  Approved = 4,
  Rejected = 5,
  Cancelled = 6,
}

export const takenTaskStatuses: Array<TakenTaskStatus> = [
  TakenTaskStatus.Created,
  TakenTaskStatus.InProgress,
  TakenTaskStatus.Completed,
  TakenTaskStatus.Approved,
  TakenTaskStatus.Rejected,
  TakenTaskStatus.Cancelled,
]

export const takenTaskStatusSelect = takenTaskStatuses.map((x) => {
  return { value: x, text: getTakenTaskStatusDisplay(x) }
})

export function getTakenTaskStatusDisplay(status: TakenTaskStatus): string {
  switch (status) {
    case TakenTaskStatus.Created:
      return 'Создано'
    case TakenTaskStatus.InProgress:
      return 'Взято в работу'
    case TakenTaskStatus.Completed:
      return 'Выполнено'
    case TakenTaskStatus.Approved:
      return 'Одобрено'
    case TakenTaskStatus.Rejected:
      return 'Отклонено'
    case TakenTaskStatus.Cancelled:
      return 'Отменено'
  }
  return 'неизвестно'
}

export function getTakenStatusIcon(status: TakenTaskStatus): string {
  switch (status) {
    case TakenTaskStatus.Created:
    case TakenTaskStatus.InProgress:
      return 'mdi-clock'
    case TakenTaskStatus.Completed:
      return 'mdi-check'
    case TakenTaskStatus.Approved:
      return 'mdi-check-circle'
    case TakenTaskStatus.Rejected:
      return 'mdi-close-circle'
    case TakenTaskStatus.Cancelled:
      return 'mdi-account-cancel'
  }
  return ''
}

export function getTakenStatusIconColor(status: TakenTaskStatus): string {
  switch (status) {
    case TakenTaskStatus.Created:
    case TakenTaskStatus.InProgress:
      return 'primary'
    case TakenTaskStatus.Completed:
      return 'warning'
    case TakenTaskStatus.Approved:
      return 'success'
    case TakenTaskStatus.Rejected:
      return 'error'
    case TakenTaskStatus.Cancelled:
      return 'error'
  }
  return ''
}

export enum SocialKind {
  VK = 1,
  OK = 2,
  FB = 3,
}

export function getSocialKindDisplay(kind: SocialKind): string {
  switch (kind) {
    case SocialKind.VK:
      return 'Вконтакте'
    case SocialKind.OK:
      return 'Одноклассники'
    case SocialKind.FB:
      return 'Facebook'
  }
  return ''
}

export function getSocialKindIcon(kind: SocialKind): string {
  switch (kind) {
    case SocialKind.VK:
      return 'mdi-vk'
    case SocialKind.OK:
      return 'mdi-odnoklassniki'
    case SocialKind.FB:
      return 'mdi-facebook'
  }
  return ''
}

export const socialKinds = [SocialKind.VK, SocialKind.OK, SocialKind.FB]
export const socialKindSelect = socialKinds.map((x) => {
  return { value: x, text: getSocialKindDisplay(x) }
})

export enum GoalKind {
  Like = 1,
  Repost = 2,
  Comment = 3,
  Subscribe = 4,
}

export function getGoalKindDisplay(kind: GoalKind): string {
  switch (kind) {
    case GoalKind.Like:
      return 'Лайк'
    case GoalKind.Repost:
      return 'Репост'
    case GoalKind.Comment:
      return 'Комментарий'
    case GoalKind.Subscribe:
      return 'Подписка'
  }
  return ''
}

export function getGoalKindIcon(kind: GoalKind): string {
  switch (kind) {
    case GoalKind.Like:
      return 'Лайк'
    case GoalKind.Repost:
      return 'mdi-share'
    case GoalKind.Comment:
      return 'mdi-comment-outline'
    case GoalKind.Subscribe:
      return 'mdi-account-plus-outline'
  }
  return ''
}

export const goalsKinds = [GoalKind.Like, GoalKind.Repost, GoalKind.Comment, GoalKind.Subscribe]
export const goalsKindSelect = goalsKinds.map((x) => {
  return { value: x, text: getGoalKindDisplay(x) }
})
